import type { ReactNode } from "react";
import { Link } from "react-router-dom";

export function NotFoundPage(): ReactNode {
  return (
    <div className="space-y-3">
      <h1 className="text-2xl font-semibold text-slate-800">Not found</h1>
      <p className="text-sm text-slate-600">That page doesn’t exist.</p>
      <Link to="/" className="text-sm text-oxbo underline">
        Back to dashboard
      </Link>
    </div>
  );
}
